import { render, staticRenderFns } from "./cardgrid.vue?vue&type=template&id=1f62a604&scoped=true"
import script from "./cardgrid.vue?vue&type=script&lang=js"
export * from "./cardgrid.vue?vue&type=script&lang=js"
import style0 from "./cardgrid.vue?vue&type=style&index=0&id=1f62a604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f62a604",
  null
  
)

export default component.exports